<template>
  <div :class="{ 'web-session-shell': auth.browser, 'web-page-frame': auth.browser }">
    <div v-if="!auth.browser && auth.expired" class="app-expired" role="alert">登录信息已失效，请返回 App 重新进入。</div>
    <web-page-header v-if="auth.browser && $route.matched.length && auth.session && !['/login', '/web/home', '/web/manage'].includes($route.path)" :title="pageTitle" @back="backHome" />
    <slot />
  </div>
</template>
<script>
import { webAuth } from '@/utils/web-auth'
import WebPageHeader from './WebPageHeader.vue'
import { webEntries } from '@/utils/web-navigation'
export default {
  name: 'WebSessionShell', components: { WebPageHeader },
  data() { return { auth: webAuth } },
  computed: {
    pageTitle() { const entry = webEntries.find(item => item.path === this.$route.path); return this.$route.path === '/dispatchCenter' && this.$route.query.gis === 'true' ? String(this.$route.query.title || 'GIS地图') : entry ? entry.title : (typeof this.$route.query.title === 'string' ? this.$route.query.title : '') }
  },
  watch: {
    'auth.browser': {
      immediate: true,
      handler(browser) {
        const viewport = document.querySelector('meta[name="viewport"]')
        if (!viewport) return
        if (browser) {
          if (this.originalViewport === undefined) this.originalViewport = viewport.getAttribute('content')
          viewport.setAttribute('content', this.originalViewport + ', viewport-fit=cover')
        } else if (this.originalViewport !== undefined) {
          viewport.setAttribute('content', this.originalViewport)
          delete this.originalViewport
        }
      }
    }
  },
  beforeDestroy() {
    const viewport = document.querySelector('meta[name="viewport"]')
    if (viewport && this.originalViewport !== undefined) viewport.setAttribute('content', this.originalViewport)
  },
  methods: {
    backHome() { if (this.$route.path === '/web/settings' && this.$route.query.section) { this.$router.push({ path: '/web/settings', query: { title: '设置', fromTab: 'profile' } }); return } this.$router.push({ path: '/web/home', query: { tab: this.$route.query.fromTab } }) }
  }
}
</script>
<style scoped>
.web-session-shell { height: 100vh; height: 100dvh; overflow: auto; background: #f2f7fc; }
.web-page-frame { width: 100%; max-width: 600px; contain: layout; margin: 0 auto; box-sizing: border-box; box-shadow: -1px 0 #e7f0f8, 1px 0 #e7f0f8; }
.web-page-frame ::v-deep > :not(.page-header) { max-width: 100%; box-sizing: border-box; }
.app-expired { background: #fdf6ec; color: #94651d; padding: 12px 16px; font-size: 14px; line-height: 1.6; text-align: left; }
</style>
<style>
.web-logout-confirm { width: calc(100% - 32px); max-width: 420px; box-sizing: border-box; }.web-logout-confirm .el-button { min-height: 40px; white-space: normal; line-height: 1.5; }.web-logout-confirm .el-button--primary { background: #5ba1e6; border-color: #5ba1e6; }.web-logout-confirm .el-message-box__message { overflow-wrap: anywhere; }
</style>
